module.exports = __webpack_public_path__ + "static/media/arrowdownwardgreen.ef527d93.svg";